export const COPY = {
  menu: {
    title: 'AR RUSH',
    subtitle: 'Learn AR by moving the work',
    startButton: 'Start — AR floor onboarding',
    endlessButton: 'Advanced mode — desktop crunch',
    bestScoreLabel: 'Best craft score',
    bestDsoLabel: 'Best DSO',
    daysCompletedLabel: 'Days completed',
  },
  menuBar: {
    unreadLabel: 'Unread:',
    slackLabel: 'Slack:',
  },
  inbox: {
    title: 'Inbox',
  },
  spreadsheet: {
    title: 'AR Spreadsheet — Cascade Foods',
    tabOpenInvoices: 'Open Invoices',
    tabAgingReport: 'Aging Report',
    columnCustomer: 'Customer',
    columnInvoice: 'Invoice #',
    columnAmount: 'Amount',
    columnIssued: 'Issued',
    columnTerms: 'Terms',
    columnAging: 'Aging',
    columnStatus: 'Status',
    bucket0_30: '0–30 days',
    bucket31_60: '31–60 days',
    bucket61_90: '61–90 days',
    bucket90plus: '90+ days',
    totalLabel: 'Total open:',
  },
  dunning: {
    title: 'Send dunning — Acme Corp',
    prompt: 'Acme Corp — $42,000 outstanding — oldest invoice 127 days past due.',
    subprompt: 'Pick escalation level:',
    templates: {
      firstNotice: {
        label: '1st Notice',
        blurb: 'Friendly reminder. Best for 0–30 day aging.',
      },
      pastDue: {
        label: 'Past Due',
        blurb: 'Firm reminder. Best for 31–60 day aging.',
      },
      finalNotice: {
        label: 'Final Notice',
        blurb: 'Last warning before collections. Best for 61–90 day aging.',
      },
      collectionsReferral: {
        label: 'Collections Referral',
        blurb: 'Escalate to third-party collections. Best for 90+ day aging.',
      },
    },
    sentToastPrefix: 'Dunning sent to Acme Corp —',
    cancelButton: 'Not now',
  },
  cashApplication: {
    title: 'Apply payment — Wire #W-2093',
    wireSummary: '$18,000 received via wire transfer',
    remittanceHint: 'Remittance reference: "Peak Industries — May invoices"',
    customerPickerPrompt: 'Which customer is this payment from?',
    allocationPrompt: (customer: string) =>
      `Apply $18,000 across ${customer}'s open invoices:`,
    appliedLabel: 'Applied:',
    unappliedLabel: 'Unapplied:',
    applyButton: 'Apply',
    removeButton: 'Remove',
    confirmButton: 'Confirm & close',
    cancelButton: 'Cancel',
    backButton: '← Change customer',
    sentToastPrefix: 'Payment applied —',
  },
  shortPay: {
    title: 'Short-pay received — Wire #W-3114',
    wireSummary: 'TechStart paid $4,200 on a $5,000 invoice (INV-4007)',
    subprompt: 'How do you want to resolve this?',
    choices: {
      applyAndChase: {
        label: 'Apply $4,200 and chase the $800',
        blurb: 'Credit the payment. Open a follow-up to collect the remaining $800.',
      },
      creditMemo: {
        label: 'Investigate — possible credit memo',
        blurb: 'Hold before applying. Check if a credit memo or dispute is already in flight.',
      },
      reject: {
        label: 'Reject the payment',
        blurb: "Send back. Don't apply until the amount is reconciled with the customer.",
      },
    },
    sentToastPrefix: 'Short-pay logged —',
    cancelButton: 'Decide later',
  },
  dispute: {
    title: 'Log dispute — Acme Corp · INV-4412',
    subprompt: 'What kind of dispute is this?',
    choices: {
      poMismatch: { label: 'PO mismatch', blurb: 'Amount or item differs from the purchase order.' },
      amount: { label: 'Amount disagreement', blurb: 'Customer believes the invoice total is wrong.' },
      billingError: { label: 'Billing error', blurb: 'Duplicate charge, wrong customer, wrong period.' },
      other: { label: 'Other', blurb: "Doesn't fit the usual buckets. Still log it." },
    },
    amountLabel: 'Amount disputed',
    submitButton: 'Log dispute',
    cancelButton: 'Cancel',
    toastPrefix: 'Dispute logged —',
    readerActionButton: 'Log dispute',
    readerLoggedBadge: '✓ Logged',
  },
  slack: {
    title: 'Slack — Jamie',
    emptyHint: 'no messages yet',
  },
  collectionsCall: {
    callerName: 'Marcus Gomez',
    callerCompany: 'Atlas Trading',
    callerSubtitle: '$14,500 outstanding · 92 days past due',
    hangupButton: 'Hang up',
    ptpFormTitle: 'What did they commit to?',
    ptpAmountLabel: 'Amount',
    ptpDateLabel: 'Date',
    ptpAmountOptions: ['$5,000', '$7,500', '$10,000', '$14,500 (full)', 'No specific amount'],
    ptpDateOptions: ['This Friday', 'Next Friday', 'End of month', 'Within 30 days', 'No date set'],
    ptpSubmitButton: 'Log promise-to-pay',
    ptpSkipButton: 'Skip — no firm commitment',
    toastSuccess: 'PTP logged.',
    toastFail: 'Call ended.',
  },
  writeOff: {
    title: 'Write off — Delta Retail · INV-3002',
    subtitle: '$800 · 118 days past due · CFO directed',
    consequence: "This $800 will be recognized as bad debt on this period's P&L.",
    body: 'Delta Retail has been on the 90+ aging bucket for over four months. CFO Priya has flagged it for write-off — recovery probability is low and the staff time to chase exceeds the recovery value.',
    approveButton: 'Approve write-off',
    declineButton: 'Hold for review',
    toastApproved: 'Write-off approved.',
    toastDeclined: 'Write-off held for review.',
  },
  dso: {
    menuLabel: 'DSO:',
    menuPlaceholder: '—',
    modalTitle: "Today's DSO: {dso} days",
    industryLine: 'Industry median: 41',
    targetLine: 'Cascade Foods target: 35',
    explainer:
      'DSO measures how long, on average, an invoice sits unpaid. Lower DSO = healthier cash flow.',
    contextLine:
      'Yours is high because the 90+ bucket grew today — which is what month-end close looks like everywhere.',
    dismissButton: 'Got it',
  },
  ending: {
    beat2Slack:
      '5pm. books close at midnight. go home — tomorrow morning at 9, this all starts again.',
    beat3Header: "Tomorrow's pile:",
    beat4LockedTitle: (displayTitle: string): string => `🔒 ${displayTitle}`,
    beat4LockedBody: "you haven't met this one yet.",
    beat4CaptionFormat: 'unlocked {time} — {hook}',
    beat4CaptionNoHook: 'unlocked {time}',
    beat4SkipHint: 'skip →',
    beat5Title: 'What you did today.',
    beat5Rows: {
      dunningSent: 'Dunning sent',
      dunningBucketOk: 'right bucket?',
      cashApplied: 'Cash applied',
      cashCustomerOk: 'correct customer?',
      shortPays: 'Short-pays resolved',
      disputes: 'Disputes logged',
      unapplied: 'Unapplied at close',
      promises: 'Promises secured',
      promisesDetail: 'solid · soft',
      writeOffs: 'Write-offs',
      writeOffsDetail: 'approved · held',
      paymentsExpired: 'Wires expired',
      paymentsExpiredDetail: 'unapplied & gone',
      emailsActioned: 'Emails triaged',
      emailsActionedDetail: 'right call',
      liveScore: 'Craft score',
      dso: "Today's DSO",
      dsoSuffix: 'days',
      noneMarker: '—',
    },
    beat5Closing: 'Tomorrow morning at 9, this all happens again.',
    punchLine1: 'You just spent {minutes} minutes on this.',
    punchLine2: 'Fazeshift spent 0.',
    backButton: 'Back to Menu',
    quizTitle: '8 questions. One per word.',
    quizSubtitle: 'Pick the answer that fits how you used it today.',
    quizSkip: 'Skip quiz →',
    quizCorrect: 'correct',
    quizScoreFormat: 'Vocab quiz: {score}/8',
    shareTitle: 'Want to share?',
    shareCopy: 'Copy share text',
    shareDownload: 'Download image',
    shareDone: 'Done',
    shareCopied: 'Copied to clipboard',
  },
};
